<template>
  <b-tabs class="w-100" lazy>
    <b-tab
      v-for="(label, key) in keyToLabel"
      :key="key"
      :active="key === 'dns'"
      :disabled="key === 'totalServers' || key === 'addresses'"
      @click="resetServerDetails()"
      lazy
    >
      <template #title>
        <div v-b-tooltip.hover :title="tabTooltipText(key)">
          <strong>{{ label }}</strong>
          <p v-if="serverLengthsLoaded">Total: {{ serviceToEnterpriseServersLength[seviceToServerCountLabel[key]] }}</p>
        </div>
      </template>
      <div v-if="validTab(key)">
        <ServiceTable
          :timeRange="timeRange"
          :url="serviceUrl(key)"
          :addressCountUrl="addressCountServiceUrl(key)"
          :getZonesUrl="getZonesUrl(key)"
          :serviceType="key"
        >
        </ServiceTable>
        <ServerDetails :timeRange="timeRange" :serviceType="key"></ServerDetails>
      </div>
      <div v-else>
        <b-row v-if="isIDSLogsTab(key)">
          <b-tabs class="w-100 mx-2" lazy>
            <b-tab title="NetworkIDS" active>
              <SuricataAlertsTable
                :timeRange="timeRange"
              ></SuricataAlertsTable>
            </b-tab>
          </b-tabs>
        </b-row>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';
import ServiceTable from '@/xvisor/components/security/ServiceTable.vue';
import SuricataAlertsTable from '@/xvisor/components/security/SuricataAlertsTable.vue';
import ServerDetails from './ServerDetails.vue';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
  },
  components: {
    ServerDetails,
    ServiceTable,
    SuricataAlertsTable,
  },
  data() {
    return {
      keyToLabel: {
        dns: 'DNS',
        ssh: 'SSH',
        http: 'HTTP',
        https: 'HTTPS',
        other: 'Other',
        addresses: 'Unique Servers',
        idsLogs: 'Security Events',
      },
      serviceToEnterpriseServersLength: {},
      seviceToServerCountLabel: {
        dns: 'dnsServerCount',
        ssh: 'sshServerCount',
        http: 'httpServerCount',
        https: 'httpsServerCount',
        other: 'otherServerCount',
        addresses: 'totalAddresses',
        idsLogs: 'idsLogCount',
      },
      serverLengthsLoaded: false,
    };
  },
  async mounted() {
    await this.populateServerLengths();
  },
  watch: {
    async timeRange() {
      await this.populateServerLengths();
    },
  },
  methods: {
    resetServerDetails() {
      SecurityEventBus.$emit('update-selected-server', null);
    },
    // TODO: This is used to prevent unused tabs from displaying any data. Remove this when other tabs are completed.
    validTab(key) {
      const validList = ['dns', 'ssh', 'http', 'https', 'other'];
      return validList.includes(key);
    },
    isIDSLogsTab(key) {
      return key === 'idsLogs';
    },
    isAlertsTab(key) {
      return key === 'alerts';
    },
    serviceUrl(key) {
      return `/security/${key}/list.json`;
    },
    addressCountServiceUrl(key) {
      return `/security/${key}/totaladdresses.json`;
    },
    getZonesUrl(key) {
      return `/security/${key}/zones.json`;
    },
    async populateServerLengths() {
      this.serverLengthsLoaded = false;
      try {
        const [serversRes, suricataAlertCount] = await Promise.all([
          this.$http.get('/security/totalservers.json', this.httpParams),
          this.$http.get('/alerts/suricata/totalalertcount.json', this.httpParams),
        ]);
        this.serviceToEnterpriseServersLength = serversRes.data;
        this.serviceToEnterpriseServersLength.idsLogCount = suricataAlertCount.data.total;
      } finally {
        this.serverLengthsLoaded = true;
      }
    },
    tabTooltipText(key) {
      if (key === 'idsLogs') {
        return 'Count of All Security Events';
      }
      const label = this.keyToLabel[key];
      return `Count of Unique Enterprise ${label} Servers`;
    },
  },
  computed: {
    httpParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
        },
      };
    },
  },
};
</script>
